'use strict'

import api from './api.js'
import response from './response.js'
import vacancy from './vacancy/index.js'

/**
 * situation object contains data, which is differ in special process and product
 */
export default {
  namespaced: true,
  modules: {
    api,
    response,
    vacancy
  }
}
